
import { Model } from 'backbone';
import Immutable from 'immutable';

class NotificationDetailsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default NotificationDetailsModel;
